import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';
import moment from 'moment';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import EntityStateUpdater from 'component/EntityStateUpdater';

import FormTextarea from 'components/forms/FormTextarea';
import FormTimePicker from 'components/forms/FormTimePicker';
import DatePicker from 'components/forms/DatePicker';

import Loader from 'components/layout/Loader';

import Entity from 'components/Entity';
import Data from 'components/Data';

import { entityMetaMapping } from 'js/constants';

class OrderSendPickupInvite extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entity: null,
      entityLoaded: false,
    };

    this.entity = new Entity();
    this.entity.setData({
      inviteDate: moment()
        .add(2, 'days')
        .toISOString(),
    });

    if (
      props.meta[entityMetaMapping.orderActionPickupInvite] !== undefined &&
      !props.meta[entityMetaMapping.orderActionPickupInvite].pending
    ) {
      this.entity.setMeta(props.meta, entityMetaMapping.orderActionPickupInvite);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = () => {
    const { meta } = this.props;

    if (
      meta[entityMetaMapping.orderActionPickupInvite] !== undefined &&
      !meta[entityMetaMapping.orderActionPickupInvite].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.orderActionPickupInvite);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          if (this.state.entity.isValid) {
            this.props.onSubmit(this.props.order.id, this.state.entity.processedData);
          }
        }
      );
    }, 150);

    return false;
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      show,
      close,
      order,
      formStatus,
      user,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    const disabled = formStatus.pending;
    const timezone = user && user.profile ? user.profile.timezone : 'UTC';

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.pickup_invite}{' '}
            <span class="small hint-text">
              {messages.order} {order.id}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="orderActionPickupInvite" />

          {entityLoaded ? (
            <form type="put" onSubmit={this.onSubmit}>
              <div class="m-b-20">
                <div class="form-group-attached">
                  <Row>
                    <Col xs={6}>
                      <DatePicker
                        label={messages.pick_up_time}
                        name="inviteDate"
                        value={entity.getInviteDate()}
                        minDate={moment()}
                        locale={appIntl.locale}
                        displayTz={timezone}
                        meta={entity.getInviteDateMetaInformation()}
                        validation={entity.getInviteDateValidationResult()}
                        onChange={this.updateEntity}
                      />
                    </Col>
                    <Col xs={6}>
                      <FormTimePicker
                        label={messages.pick_up_time}
                        name="inviteDate"
                        value={entity.getInviteDate()}
                        locale={appIntl.locale}
                        displayTz={timezone}
                        meta={entity.getInviteDateMetaInformation()}
                        validation={entity.getInviteDateValidationResult()}
                        onChange={this.updateEntity}
                      />
                    </Col>
                  </Row>
                  <FormTextarea
                    label={messages.content}
                    name="inviteText"
                    value={entity.getInviteText()}
                    meta={entity.getInviteTextMetaInformation()}
                    validation={entity.getInviteTextValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                </div>
              </div>

              <Button bsStyle="primary" bsSize="lg" block disabled={formStatus.pending} type="submit">
                {formStatus.pending ? <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

                {messages.send}
              </Button>
            </form>
          ) : (
            <Loader />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
    formStatus: state.formStatus.orderActionPickupInvite,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (orderId, args) => {
      formStatusDispatchHelper(
        'orderActionPickupInvite',
        '/api/orders/' + orderId + '/pickupInvite.json',
        args,
        'put',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(OrderSendPickupInvite)
  )
);
